import React, { useState, useEffect } from 'react'
//*material
import { Backdrop, CircularProgress } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Container from '@material-ui/core/Container'
import DataTable from 'react-data-table-component'
//*antd
import Modal from 'antd/es/modal';
//*styles and assets
import { TelematicsStyles } from '../TelematicsStyles'
import { useTranslation } from 'react-i18next'
//*Redux
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { useHistory } from 'react-router-dom'
import * as navigationActions from '../../../actions/common/NavigationActions'
import * as TelematicsActions from '../../../actions/telematics/TelematicsActions'
//*Components
import { customStyleSecondary } from '../../common/CommonStyles'

const Erros = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { match: { params } } = props;
    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }
    const [openBackdrop, setOpenBackdrop] = useState(false);

    useEffect(() => {
        handleOpenBackdrop()

        props.actions.fetch_Invoice_Errors(props.userLanguage, props.userToken, params.instalationId, onError, onSuccess)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    const errorColumns = [
        {
            name: t('telematicsDetail.fileName'),
            selector: 'fileName',
            sortable: true,
            cell: row => row.fileName
        },
        {
            name: t('telematicsDetail.registerDate'),
            selector: 'createDate',
            sortable: true,
            cell: row => row.createDate
        },
        {
            name: t('telematicsDetail.errorMessage'),
            selector: 'message',
            sortable: true,
            cell: row => row.message
        },
        {
            name: t('telematicsDetail.invoiceFileType'),
            selector: 'fileType',
            sortable: true,
            cell: row => row.fileType
        }
    ]

    return (
        <Container className={classes.generalBorder}>
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <br />
            <DataTable
                columns={errorColumns}
                data={props.invoiceRejectedList}
                defaultSortField="installationOrderId"
                customStyles={customStyleSecondary}
                highlightOnHover
                noHeader
                dense
                responsive
                striped
                pointerOnHover
                pagination
                paginationComponentOptions={paginationOptions}
                noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
            />
            {
                props.invoiceRejectedList && props.invoiceRejectedList.length < 1 && (
                    <Grid container item xs={12}><br /></Grid>
                )
            }
        </Container>
    )
}

const mapStateToProps = state => ({
    invoiceRejectedList: state.TelematicsReducer.listRejectedInvoices,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(Erros))